import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ExternalLinkBlock, Heading, Section } from '../s'
import Paragraph from 'components/typography/paragraph'

const AltinnHowToUse = ({ data }) => (
    <Section>
        <Heading>
            <FormattedMessage
                id="integration_heading_how_to_use"
                defaultMessage="How to use" />
        </Heading>
        <Paragraph>
            <FormattedMessage
                id="integration_altinn_how_to_use_preamble"
                defaultMessage="To get started, you will need to give Huma access to your company in Altinn." />
        </Paragraph>
        <ExternalLinkBlock href={data.knowledgebaseUrl}>
            <FormattedMessage
                id="integration_altinn_link_knowledgebase"
                defaultMessage="Using the Altinn / NAV integration" />
        </ExternalLinkBlock>
    </Section>
)

export default AltinnHowToUse